import { merge, mergeDeep } from '../../../../utils/state';
import { TYPES } from './actions';
import entity from '../../entities/billing/entity';

const coreReducer = entity.getReducer();

const initialState = {
  creditCardSummary: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TYPES.GET_CREDIT_CARD_SUMMARY:
      return merge(state, {
        creditCardSummary: {},
        isLoading: true,
      });
    case TYPES.GET_CREDIT_CARD_SUMMARY_SUCCESS:
      return mergeDeep(state, {
        creditCardSummary: action.payload,
        error: false,
        isLoading: false,
      });
    case TYPES.GET_CREDIT_CARD_SUMMARY_ERROR:
      return merge(state, {
        error: action.payload,
        isLoading: false,
      });
    default:
      return coreReducer(state, action);
  }
}
